import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { SquaresFour, GearSix, SignOut, Broadcast, EnvelopeSimple, UsersThree, PaperPlaneRight, List, X, Vault, ChatCircleText } from "@phosphor-icons/react";

export default function AppShell({ children, header }) {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const logout = () => { localStorage.removeItem("jr_token"); nav("/login"); };
  const item = ({ isActive }) =>
    `flex items-center gap-3 px-3 py-2 rounded-sm text-sm transition-colors ${
      isActive ? "bg-zinc-800 text-zinc-50" : "text-zinc-400 hover:text-zinc-100 hover:bg-zinc-900"
    }`;
  const close = () => setOpen(false);

  return (
    <div className="min-h-screen w-full bg-[#09090b] text-zinc-50 grain">
      {/* Mobile top-bar */}
      <div className="lg:hidden sticky top-0 z-40 flex items-center justify-between px-4 py-3 border-b border-zinc-800 bg-[#09090b]" data-testid="mobile-topbar">
        <div className="flex items-center gap-2.5">
          <div className="w-7 h-7 border border-zinc-600 grid place-items-center"><span className="mono text-xs font-semibold">JR</span></div>
          <div className="leading-tight">
            <div className="mono text-[9px] tracking-[0.2em] uppercase text-zinc-500">Jack Royals</div>
            <div className="text-xs">LLC Holdings</div>
          </div>
        </div>
        <button onClick={() => setOpen(v => !v)} className="p-2 border border-zinc-800 rounded-sm" data-testid="mobile-menu-toggle" aria-label="Toggle menu">
          {open ? <X size={18} /> : <List size={18} />}
        </button>
      </div>

      <div className="flex min-h-screen relative z-10">
        {/* Backdrop for mobile drawer */}
        {open && <div className="fixed inset-0 bg-black/60 z-30 lg:hidden" onClick={close} />}

        <aside
          className={`fixed lg:static inset-y-0 left-0 z-40 w-64 lg:w-56 shrink-0 border-r border-zinc-800/80 flex flex-col bg-[#09090b] transform transition-transform duration-200 ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}
          data-testid="sidebar"
        >
          <div className="px-4 py-5 border-b border-zinc-800/80 hidden lg:block">
            <div className="flex items-center gap-2.5">
              <div className="w-8 h-8 border border-zinc-600 grid place-items-center">
                <span className="mono text-sm font-semibold">JR</span>
              </div>
              <div className="leading-tight">
                <div className="mono text-[10px] tracking-[0.2em] uppercase text-zinc-500">Jack Royals</div>
                <div className="text-sm">LLC Holdings</div>
              </div>
            </div>
          </div>

          <nav className="p-3 space-y-1 flex-1 pt-4" onClick={close}>
            <div className="overline px-3 pb-2 pt-2">Console</div>
            <NavLink to="/" end className={item} data-testid="nav-dashboard"><SquaresFour size={18} /> Portfolio Board</NavLink>
            <NavLink to="/scans" className={item} data-testid="nav-scans"><Broadcast size={18} /> Data Analysis</NavLink>
            <NavLink to="/handoffs" className={item} data-testid="nav-handoffs"><EnvelopeSimple size={18} /> Handoffs</NavLink>
            <NavLink to="/outreach" className={item} data-testid="nav-outreach"><PaperPlaneRight size={18} /> Correspondence</NavLink>
            <NavLink to="/buyers" className={item} data-testid="nav-buyers"><UsersThree size={18} /> Counterparties</NavLink>
            <NavLink to="/workshop" className={item} data-testid="nav-workshop"><ChatCircleText size={18} /> Workshop</NavLink>
            <NavLink to="/vault" className={item} data-testid="nav-vault"><Vault size={18} /> Docs Vault</NavLink>
            <NavLink to="/settings" className={item} data-testid="nav-settings"><GearSix size={18} /> Settings</NavLink>
          </nav>

          <button onClick={logout} className="m-3 px-3 py-2 rounded-sm text-sm text-zinc-400 hover:text-zinc-100 hover:bg-zinc-900 flex items-center gap-3 border border-transparent hover:border-zinc-800" data-testid="btn-logout">
            <SignOut size={18} /> Sign out
          </button>
        </aside>

        <div className="flex-1 flex flex-col min-w-0 w-full">
          {header}
          <main className="flex-1 min-h-0">{children}</main>
        </div>
      </div>
    </div>
  );
}
